export const SEND_DELIVERABLE_ALL = 'Dyzio/SendDeliverableAll/SEND_DELIVERABLE_ALL';



/** WEBPACK FOOTER **
 ** ./src/containers/send-deliverable-all-modal/constants.js
 **/